import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { Organization } from '../../models';
import {
  canReinviteCustomerOwner,
  isCustomerInvitationAccepted,
} from '../../utils/organization.utils';

type CustomerRowMenuTrigger = 'card' | 'table';

/**
 * Per-row action menu for managed customer orgs (switch context, documents,
 * resend invitation). Emits intent only — parent routes handle navigation.
 */
@Component({
  selector: 'app-customer-row-menu',
  imports: [MatIconModule, MatMenuModule, MatTooltipModule, TranslocoModule],
  templateUrl: './customer-row-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerRowMenuComponent {
  readonly customer = input.required<Organization>();
  readonly trigger = input<CustomerRowMenuTrigger>('table');

  readonly switchContext = output<Organization>();
  readonly openDocuments = output<Organization>();
  readonly reinvite = output<Organization>();

  protected readonly canReinvite = computed(() => canReinviteCustomerOwner(this.customer()));
  protected readonly isAccepted = computed(() => isCustomerInvitationAccepted(this.customer()));

  protected readonly triggerClass = computed(() =>
    this.trigger() === 'card' ? 'card-menu-button' : 'data-table-menu-btn'
  );
}
